module.exports = __webpack_public_path__ + "static/media/MF2_0070.6fdf4787.webp";